import { LineString, Polygon } from 'src/common-services/types/geojson-types'

export const LAST_TRAFFIC_DATA_SET = 2022

export const TrafficDataSets = {
  2020: {
    id: 2020,
    label: '2020',
  },
  2021: {
    id: 2021,
    label: '2021',
  },
  2022: {
    id: 2022,
    label: 'Latest Year (2022)',
  },
}

export type TrafficDataSet = keyof typeof TrafficDataSets

export type GetTrafficRequest = {
  year: TrafficDataSet
  polygon: Polygon
}

export type TrafficInfo = {
  segmentId: string // seg_id
  complementarySegmentId: string | null // compseg_id
  roadName: string | null // roadname
  geojson: LineString
  averageAADT: number
}

export type TrafficResponse = TrafficInfo[]

export type TrafficInfoVolume = { volume: number; hour: number; time: string }
export type TrafficInfoStats = { dayCode: string; dayName: string; aadt: number; volume: TrafficInfoVolume[] }
export type TrafficSegmentResponse = { segmentId: string; stats: TrafficInfoStats[] }

export type TrafficH3Datum = {
  h3_index: string
  segment_count: number
  min_aadt: number
  max_aadt: number
  average_aadt: number
  total_aadt: number
  p50_aadt: number
}

export type TrafficH3ByPolygonRequest = {
  year: number
  polygon: Polygon
  resolution: number
  fields: Array<keyof TrafficH3Datum>
}

export type TrafficH3ByPolygonResponse = Array<TrafficH3Datum>
